import { Outlet, useNavigate } from "react-router-dom";
import {
  Bell,
  CalendarOff,
  Clock,
  Home,
  ListChecks,
  Trophy,
  User,
} from "lucide-react";
import { AppShell } from "@/components/shell/app-shell";
import { clearHrEmployeeSession, getHrEmployeeSession } from "@/lib/auth/storage";

const groups = [
  {
    label: "Today",
    links: [{ href: "/employee", label: "Home", icon: Home, exact: true }],
  },
  {
    label: "Work",
    links: [
      { href: "/employee/tasks", label: "Tasks", icon: ListChecks },
      { href: "/employee/hours", label: "Hours", icon: Clock },
    ],
  },
  {
    label: "Time off",
    links: [{ href: "/employee/leave", label: "Leave", icon: CalendarOff }],
  },
  {
    label: "You",
    links: [
      { href: "/employee/performance", label: "Performance", icon: Trophy },
      { href: "/employee/notifications", label: "Notifications", icon: Bell },
      { href: "/employee/profile", label: "Profile", icon: User },
    ],
  },
];

const mobileLinks = [
  { href: "/employee", label: "Home", icon: Home, exact: true },
  { href: "/employee/tasks", label: "Tasks", icon: ListChecks },
  { href: "/employee/leave", label: "Leave", icon: CalendarOff },
  { href: "/employee/hours", label: "Hours", icon: Clock },
  { href: "/employee/profile", label: "Profile", icon: User },
];

export function EmployeeLayout() {
  const navigate = useNavigate();
  const name = getHrEmployeeSession()?.employee.name;

  return (
    <AppShell
      product="Employee"
      groups={groups}
      userName={name}
      mobileLinks={mobileLinks}
      onSignOut={() => {
        clearHrEmployeeSession();
        navigate("/employee/login");
      }}
    >
      <Outlet />
    </AppShell>
  );
}
